import {AddressDto} from "./address.dto";
import {PhoneDto} from "./phone.dto";
import {EmailDto} from "./email.dto";
import {isDefined, isFalse} from "../../libs/utils/epic.utils";

export class RegistryOfficeDto {

  public readonly id!: string;
  public name!: string;
  public number: string | undefined;
  public readonly system!: boolean;
  public readonly countryCode!: string;
  public readonly address: AddressDto | undefined;
  public readonly phones: PhoneDto[] = [];
  public readonly emails: EmailDto[] = [];

  constructor(init?: Partial<RegistryOfficeDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.address)) {
      this.address = new AddressDto(init?.address);
    } else {
      this.address = undefined;
    }
    if (isDefined(init?.phones)) {
      this.phones = init.phones.map((i) => new PhoneDto(i));
    } else {
      this.phones = [];
    }
    if (isDefined(init?.emails)) {
      this.emails = init.emails.map((i) => new EmailDto(i));
    } else {
      this.emails = [];
    }
  }

  public isEditable(): boolean {
    return isFalse(this.system);
  }
}
